/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchParcelResultDto } from '../../models/search-parcel-result-dto';

export interface SearchForParcelByPfi$Params {
  pfi: string;
}

export function searchForParcelByPfi(
  http: HttpClient,
  rootUrl: string,
  params: SearchForParcelByPfi$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchParcelResultDto>> {
  const rb = new RequestBuilder(rootUrl, searchForParcelByPfi.PATH, 'get');
  if (params) {
    rb.path('pfi', params.pfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchParcelResultDto>;
      }),
    );
}

searchForParcelByPfi.PATH = '/search/parcel/pfi/{pfi}';
